import { useGetOrganizationEmailIdentityQuery } from "generated/graphql";
import { useMemo } from "react";

export default function useGetOrganizationEmailIdentity() {
  const { data: graphqlData, loading, error } = useGetOrganizationEmailIdentityQuery();

  const identity = useMemo(() => {
    return graphqlData?.getOrganizationEmailIdentity ?? null;
  }, [graphqlData]);

  return { identity, loading, error } as const;
}
